import { render } from "./CancelEnvelopeModal.vue?vue&type=template&id=366f1946&scoped=true&ts=true"
import script from "./CancelEnvelopeModal.vue?vue&type=script&lang=ts"
export * from "./CancelEnvelopeModal.vue?vue&type=script&lang=ts"

import "./CancelEnvelopeModal.vue?vue&type=style&index=0&id=366f1946&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366f1946"]])

export default __exports__